import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

import constants from 'constants/index'

const UsersFilters = ({ filter, profiles = [] }) => {
  return (
    <Filters filter={filter} defaultOrder={constants.orderFilter.OLDER_CREATED}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="userName" />
      <input textfieldinput="true" label="Email" name="userEmail" />
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        <option value={constants.userCompanies.ACTIVE}>Ativo</option>
        <option value={constants.userCompanies.INACTIVE}>Inativo</option>
      </select>
      <select textfieldinput="true" label="Perfil" name="profileId">
        <option value=""></option>
        {profiles.map((profile) => (
          <option key={profile.id} value={profile.id}>
            {profile.name}
          </option>
        ))}
      </select>
    </Filters>
  )
}

UsersFilters.propTypes = {
  filter: PropTypes.object.isRequired,
  profiles: PropTypes.array,
}

export default UsersFilters
